<div class="bubble-container">
    <div
    class="bubble-item"
    *ngFor="let option of options"
    (click)="onElementClicked(option)"
    >
        <p class="align-text">
            <span><mat-icon svgIcon="cancel-close" class="blue close-icon"></mat-icon></span>
            <span class="text blue">{{extractLabelFn(option)}}</span>
        </p>
    </div>
</div>